import axios from "axios"
import {
    ASSIGN_CASH_BOX,
    UPDATE_USERS_ENDPOINT,
    UPDATE_USERS_PASS_ENDPOINT,
    USERS_ENDPOINT
} from "../../../../../../utility/SourceAPI"

/**
 * Única capa que habla con el backend de usuarios.
 * Devuelve siempre `response.data`, nunca el envoltorio de axios, y deja que el
 * error suba tal cual: quien decide qué hacer con él es el thunk (rejectWithValue).
 */

export const fetchUsers = async () => {
    const response = await axios.get(USERS_ENDPOINT)
    return response.data
}

export const fetchUsersByRole = async (roleId) => {
    const response = await axios.get(USERS_ENDPOINT, { params: { role_id: roleId } })
    return response.data
}

export const fetchUserById = async (userId) => {
    const response = await axios.get(USERS_ENDPOINT, { params: { id: userId } })
    return response.data
}

export const createUser = async (user) => {
    const response = await axios.post(USERS_ENDPOINT, user)
    return response.data
}

export const updateUser = async (userId, userData) => {
    const response = await axios.put(UPDATE_USERS_ENDPOINT.concat(userId), userData)
    return response.data
}

export const updateUserPassword = async (userId, userData) => {
    const response = await axios.put(UPDATE_USERS_PASS_ENDPOINT.concat(userId), userData)
    return response.data
}

export const assignCashBox = async (userId, user) => {
    const response = await axios.put(ASSIGN_CASH_BOX.concat(userId), user)
    return response.data
}
